module.exports = __webpack_public_path__ + "source/img/thumb-up-fill.63891a4c.svg";